var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonV2 } from "../button/Button";
export const ButtonGroupV2Item = (_a) => {
    var { children, value } = _a, props = __rest(_a, ["children", "value"]);
    return _jsx(ButtonV2, Object.assign({}, props, { children: children }));
};
export default ButtonGroupV2Item;
